/**
 * Inventory Hub Styles - Hub-specific styled components
 * Used for mock mode toggle, info banners, and other inventory-specific UI
 */
import styled from 'styled-components';
// ============================================
// MOCK MODE TOGGLE BUTTON
// ============================================
export const MockModeToggle = styled.button `
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${props => props.$active
    ? 'var(--accent-gold-bg, rgba(184, 134, 11, 0.08))'
    : 'var(--bg-secondary)'};
  color: ${props => props.$active
    ? 'var(--accent-gold, #B8860B)'
    : 'var(--text-secondary)'};
  border: 1px solid ${props => props.$active
    ? 'var(--accent-gold, #B8860B)'
    : 'var(--border-color)'};
  padding: 12px 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s;

  svg {
    font-size: 18px;
  }

  &:hover {
    background: ${props => props.$active
    ? 'rgba(184, 134, 11, 0.15)'
    : 'var(--bg-tertiary)'};
    border-color: var(--accent-gold, #B8860B);
    color: var(--accent-gold, #B8860B);
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 12px;
  }
`;
// ============================================
// MOCK MODE BADGE (Compact)
// ============================================
export const MockModeBadge = styled.div `
  background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  border: 1px solid var(--accent-gold, #B8860B);
  color: var(--accent-gold, #B8860B);
  padding: 12px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;

  &:hover {
    background: rgba(184, 134, 11, 0.15);
  }
`;
// ============================================
// MOCK INFO BANNER (Expanded)
// ============================================
export const MockInfoBanner = styled.div `
  background: var(--bg-primary);
  border: 1px solid var(--accent-gold, #B8860B);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--accent-gold, #B8860B), var(--accent-gold-light, #D4A634));
  }
`;
export const MockInfoHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
`;
export const MockInfoTitle = styled.h3 `
  font-family: 'Playfair Display', 'Adamina', serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--accent-gold, #B8860B) !important;
  margin: 0 !important;
`;
export const CloseButton = styled.button `
  background: transparent;
  border: 1px solid var(--border-color);
  font-size: 20px;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: var(--bg-tertiary);
    border-color: var(--accent-gold, #B8860B);
    color: var(--accent-gold, #B8860B);
  }
`;
export const MockInfoContent = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;
export const MockInfoSection = styled.div `
  padding: 24px;
  border-right: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.7;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 1024px) {
    border-right: none;
    border-bottom: 1px solid var(--border-color);

    &:last-child {
      border-bottom: none;
    }
  }

  strong {
    display: block;
    margin-bottom: 12px;
    color: var(--text-primary);
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  ul {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 6px;
    color: var(--text-secondary);

    &::marker {
      color: var(--accent-gold, #B8860B);
    }
  }
`;
